import { PageNotFound } from "ui-library/PageNotFound";
import { withErrorBoundary } from "utils/ErrorBoundary";

const Index = () => {
	return <PageNotFound />;
};

export default withErrorBoundary(Index);
